import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Typography, styled } from '@mui/material';
import { t } from '@/core/localization';
export const PageLoader = () => {
    return (_jsx(FlexFullPage, { children: _jsxs(InlineFlex, { children: [_jsx(CircularProgress, { color: "primary", sx: { marginRight: '1rem' } }), _jsx(Typography, { variant: "h6", children: t('preload.loading') })] }) }));
};
const FlexFullPage = styled('div')({
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
});
const InlineFlex = styled('div')({
    display: 'inline-flex',
    alignItems: 'center',
});
